import { render, staticRenderFns } from "./DashboardMarketingTickets.vue?vue&type=template&id=6e598538&scoped=true"
import script from "./DashboardMarketingTickets.vue?vue&type=script&lang=js"
export * from "./DashboardMarketingTickets.vue?vue&type=script&lang=js"
import style0 from "./DashboardMarketingTickets.vue?vue&type=style&index=0&id=6e598538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e598538",
  null
  
)

export default component.exports